<template>
  <div class="ctrl-api-histories-google-api-histories">
    <el-row>
      <el-col>
        <h2>Google API送信履歴</h2>
      </el-col>
    </el-row>
    <GoogleApiHistories :pageType="'ctrl'" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import GoogleApiHistories from "@/components/Tools02/ApiHistories/GoogleLogTable.vue";

export default {
  components: {
    GoogleApiHistories,
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rt", "tool"]),
  },
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>